import React, { useContext } from "react";
import styles from "./ServiceContent.module.scss";
import AppRequirements from "./components/AppRequirements";
import FoldingBlock from "../../../../../../../../../../components/folding/FoldingBlock";
import DomainEditor from "./components/DomainEditor";
import NetworkEditor from "./components/NetworkEditor";
import RestartPolicy from "./components/RestartPolicy";
import ServiceDockerhub from "./components/ServiceDockerhub";
import CustomAppLinks from "./components/_custom/CustomAppLinks";
import CustomAppDescriptions from "./components/_custom/CustomAppDescriptions";
import CustomAppRequirements from "./components/_custom/CustomAppRequirements";
import { connect } from "react-redux";
import { reorderApps } from "../../../../../../../_helpers/custom";
import { updateBodyBuilder } from "../../../../../../../../../../redux/actions/DeploymentActions";
import ServiceBlock from "./layouts/ServiceBlock";
import ServiceName from "./components/_custom/ServiceName";
import FormPairs from "./components/FormPairs";
import { FoldingContentContext } from "../../../../../../../../../../components/folding/FoldingContent";
import Input from "../../../../../../../../../../components/Input";
import { CardItem } from "../../../../../../../../../../components/card/Card";

function ServiceContent({app, messages, bodyBuilder, dispatch}) {

    const foldingContentContext = useContext(FoldingContentContext);

    const update = (_object) => {
        let newSelection = [...bodyBuilder[app.type]];
        const appIndex = newSelection.findIndex(a => a._id === app._id);
        newSelection = [
            ...newSelection.slice(0, appIndex),
            ...newSelection.slice(appIndex + 1),
            ...[
                {
                    ...newSelection[appIndex],
                    ..._object
                }
            ]
        ];
        newSelection = reorderApps(newSelection);
        dispatch(updateBodyBuilder({...bodyBuilder, ...{[app.type]: newSelection}}));
        foldingContentContext?.recalculateHeight?.();
    }

    return (
        <>
            <AppRequirements app={app}/>
            <div className={styles.main}>
                {/*{*/}
                {/*    !app.custom &&*/}
                {/*    <ServiceBlock id={`app-${app._id}-version`}>*/}
                {/*        <FoldingBlock*/}
                {/*            title='Version'*/}
                {/*            folded={false}*/}
                {/*            className={styles.foldMin}*/}
                {/*            id={`app-${app._id}-version`}*/}
                {/*        >*/}
                {/*            <AppVersions app={app} update={update} messages={messages}/>*/}
                {/*        </FoldingBlock>*/}
                {/*    </ServiceBlock>*/}
                {/*}*/}
                {/*{*/}
                {/*    !!app.custom &&*/}
                <ServiceBlock id={`app-${app._id}-name`}>
                    <ServiceName app={app} messages={messages} update={update}/>
                </ServiceBlock>
                {/*}*/}
                <ServiceBlock id={`app-${app._id}-dockerhub`}>
                    <ServiceDockerhub app={app} messages={messages} update={update}/>
                </ServiceBlock>
                <ServiceBlock id={`${app._id}-domain`}>
                    <FoldingBlock title='Domain' className={styles.fold} id={`${app._id}-domain`}>
                        <DomainEditor domain={app.domain} onChange={domain => update({domain: domain})}/>
                    </FoldingBlock>
                </ServiceBlock>
                <ServiceBlock id={`app-${app._id}-shared_ports`}>
                    <FoldingBlock title='Ports' className={styles.fold} id={`app-${app._id}-shared_ports`}>
                        <FormPairs
                            pair={[
                                {name: 'host_port', placeholder: 'Host port', type: 'number',},
                                {name: 'container_port', placeholder: 'Container port', type: 'number'}
                            ]}
                            app={app}
                            prop={'shared_ports'}
                            update={update}
                            messages={messages}
                        />
                    </FoldingBlock>
                </ServiceBlock>
                <ServiceBlock>
                    <FoldingBlock title='Environment' className={styles.fold} id={`env-${app._id}-block`}>
                        <FormPairs
                            pair={[
                                {name: 'key', placeholder: 'Key',},
                                {name: 'value', placeholder: 'Value',}
                            ]}
                            app={app}
                            prop={'environment'}
                            update={update}
                            messages={messages}
                        />
                    </FoldingBlock>
                </ServiceBlock>
                <ServiceBlock>
                    <FoldingBlock title='Volumes' className={styles.fold} id={`volumes-${app._id}-block`}>
                        <FormPairs
                            pair={[
                                {name: 'host_path', placeholder: 'Host path',},
                                {name: 'container_path', placeholder: 'Container path',}
                            ]}
                            app={app}
                            prop={'volumes'}
                            update={update}
                        />
                    </FoldingBlock>
                </ServiceBlock>
                <ServiceBlock>
                    <FoldingBlock
                        title='Docker-compose Command' className={styles.fold} id={`command-${app._id}-block`}
                    >
                        <Input
                            value={app.command || ''}
                            placeholder={`Command`}
                            hint={
                                <CardItem>
                                    <p>
                                        <code>command</code> overrides the default command declared by the container
                                        image, for example by Dockerfile's <code>CMD.</code>
                                    </p>
                                    <br />
                                    <a
                                        href={`https://docs.docker.com/compose/compose-file/05-services/#command`}
                                        target='_blank'
                                    >
                                        Read more about command
                                    </a>
                                </CardItem>
                            }
                            hintType={`modal`}
                            onChange={e => update({command: e.target.value})}
                        />
                    </FoldingBlock>
                </ServiceBlock>
                <ServiceBlock>
                    <FoldingBlock
                        title='Docker Entrypoint' className={styles.fold} id={`command-${app._id}-block`}
                    >
                        <Input
                            value={app.entrypoint || ''}
                            placeholder={`Entrypoint`}
                            hint={
                                <CardItem>
                                    <p>
                                        The <code>ENTRYPOINT</code> instruction is used to configure the executables
                                        that will always run after the container is initiated. For example, you can
                                        mention a script to run as soon as the container is started.
                                    </p>
                                    <br />
                                    <a
                                        href={`https://refine.dev/blog/docker-entrypoint/#introduction`}
                                        target='_blank'
                                    >
                                        Read more about Docker ENTRYPOINT
                                    </a>
                                </CardItem>
                            }
                            hintType={`modal`}
                            onChange={e => update({entrypoint: e.target.value})}
                        />
                    </FoldingBlock>
                </ServiceBlock>
                <ServiceBlock>
                    <FoldingBlock title='Networking' className={styles.fold} id={`network-${app._id}-block`}>
                        <NetworkEditor app={app} update={update}/>
                    </FoldingBlock>
                </ServiceBlock>
                <ServiceBlock>
                    <FoldingBlock title='Restart policy' className={styles.fold} id={`restart-${app._id}-block`}>
                        <RestartPolicy app={app} update={update}/>
                    </FoldingBlock>
                </ServiceBlock>
                {
                    !!app.custom &&
                    <>
                        <ServiceBlock id={`app-${app._id}-meta`}>
                            <FoldingBlock
                                title='Other settings'
                                folded={true}
                                className={styles.fold}
                                id={`app-${app._id}-meta`}
                            >
                                <CustomAppLinks app={app} update={update} messages={messages}/>
                                <CustomAppDescriptions app={app} update={update} messages={messages}/>
                            </FoldingBlock>
                        </ServiceBlock>
                        <ServiceBlock>
                            <FoldingBlock
                                title='Requirements'
                                folded={true}
                                className={styles.fold}
                                id={`app-${app._id}-req`}
                            >
                                <CustomAppRequirements app={app} update={update} messages={messages}/>
                            </FoldingBlock>
                        </ServiceBlock>
                    </>
                }
            </div>
        </>
    )
}

const mapStateToProps = state => ({
    bodyBuilder: state.deployment.bodyBuilder,
    messages: state.deployment.messages,
})

export default connect(mapStateToProps)(ServiceContent)